var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.21967 18.5303C8.92678 18.2374 8.92678 17.7626 9.21967 17.4697L14.6893 12L9.21967 6.53033C8.92678 6.23744 8.92678 5.76256 9.21967 5.46967C9.51256 5.17678 9.98744 5.17678 10.2803 5.46967L16.2803 11.4697C16.5732 11.7626 16.5732 12.2374 16.2803 12.5303L10.2803 18.5303C9.98744 18.8232 9.51256 18.8232 9.21967 18.5303Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-right.147b3b53b8e967f799ec8f0f69deb6d0.svg";